var _path, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconViewActive = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Layer 1",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21.91 11.57a12.78 12.78 0 00-9.91-5 12.78 12.78 0 00-9.91 5 .45.45 0 000 .54 12.87 12.87 0 009.91 5 12.79 12.79 0 009.91-5 .39.39 0 000-.54zM12 15.82a4 4 0 010-8 4 4 0 010 8z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 11.82,
  r: 1.42
})));

export default SvgIconViewActive;